module.exports = __webpack_public_path__ + "img/circle-play-sharp-regular.0c7eba89.svg";